<template>
  <div class="map-container" id="map">
  </div>
</template>

<script>
export default {
  mounted() {
    mapboxgl.accessToken = 'pk.eyJ1IjoiemNyYWlnIiwiYSI6ImNrZW1zNGR4bDA4bGYyeGw1NHowZWE0cncifQ.bll-DkmxqyX34OqsLZ_qcw';
    var map = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/streets-v11', // stylesheet location
      center: [-74.5, 40], // starting position [lng, lat]
      zoom: 9 // starting zoom
    });
  }
}
</script>
